export default {
  PackageCard__ARIA_LABEL_RATING: " out of five stars",
  PackageCard__DEPART: "Depart",
  PackageCard__DEPART_DATE_FORMAT: "MMM DD, YYYY",
  PackageCard__DURATION: (duration) => `${duration} nights hotel + flight from`,
  PackageCard__EARN_POINTS: (points) => `Earn from ${points} points per Member`,
  PackageCard__FROM: "from",
  PackageCard__IMAGE_ALT_TEXT: "Vacation package destination image",
  PackageCard__PER_GUEST: "per guest",
  packageCard__TAX_AND_FEE_INFO_TEXT: "includes estimated taxes & fees",
};
